// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e6c9208c","453":"34c5d520","455":"24efaf58","977":"d56b635d"}[chunkId] + ".chunk.js";
};